import { render, staticRenderFns } from "./PackageIndex.vue?vue&type=template&id=969e6208&scoped=true&"
import script from "./PackageIndex.vue?vue&type=script&lang=js&"
export * from "./PackageIndex.vue?vue&type=script&lang=js&"
import style0 from "./PackageIndex.vue?vue&type=style&index=0&id=969e6208&prod&lang=scss&scoped=true&"
import style1 from "./PackageIndex.vue?vue&type=style&index=1&id=969e6208&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "969e6208",
  null
  
)

export default component.exports